/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Next_Season_PeriodInputs */

const en_next_season_period = /** @type {(inputs: Next_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next Season’s Content & Duration
**7/1/2025 – 9/30/2025** (GMT+0)`)
};

const ar_next_season_period = /** @type {(inputs: Next_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محتوى الموسم المقبل ومدته
**7/1/2025 – 9/30/2025** (GMT+0)`)
};

const de_next_season_period = /** @type {(inputs: Next_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhalt und Dauer der nächsten Saison
**7/1/2025 - 9/30/2025** (GMT+0)`)
};

const es_next_season_period = /** @type {(inputs: Next_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenido y duración de la próxima temporada
**01/07/2025 - 30/09/2025** (GMT+0)`)
};

const fr_next_season_period = /** @type {(inputs: Next_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenu de la prochaine saison et durée
**01/07/2025 – 30/09/2025** (GMT+0)`)
};

const it_next_season_period = /** @type {(inputs: Next_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenuti e durata della prossima stagione 
 **7/1/2025 – 9/30/2025** (GMT+0)`)
};

const ja_next_season_period = /** @type {(inputs: Next_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のシーズンのコンテンツ＆期間
**2025年7月1日～2025年9月30日** (GMT+0)`)
};

const ko_next_season_period = /** @type {(inputs: Next_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다음 시즌 콘텐츠 및 기간
**2025/7/1 - 2025/9/30** (GMT+0)`)
};

const pt_br_next_season_period = /** @type {(inputs: Next_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteúdo e duração da próxima temporada
 **01/07/2025 – 30/09/2025** (GMT+0)`)
};

const ru_next_season_period = /** @type {(inputs: Next_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контент и продолжительность следующего сезона
**1/7/2025 г. — 30/9/2025 г.** (GMT+0)`)
};

const th_next_season_period = /** @type {(inputs: Next_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เนื้อหาและระยะเวลาของฤดูกาลถัดไป
**01/07/2025 – 30/09/2025** (GMT+0)`)
};

const tr_next_season_period = /** @type {(inputs: Next_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelecek Mevsimin İçeriği ve Süresi
**01/07/2025 - 30/09/2025**(GMT+0) `)
};

const zh_cn_next_season_period = /** @type {(inputs: Next_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一季内容与期间：
**2025/7/1 ～ 2025/9/30** (GMT+0)`)
};

const zh_tw_next_season_period = /** @type {(inputs: Next_Season_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下一季內容與期間：
**2025/7/1 ～ 2025/9/30** (GMT+0)`)
};

/**
* | output |
* | --- |
* | "Next Season’s Content & Duration **7/1/2025 – 9/30/2025** (GMT+0)" |
*
* @param {Next_Season_PeriodInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const next_season_period = /** @type {((inputs?: Next_Season_PeriodInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Next_Season_PeriodInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_next_season_period(inputs)
	if (locale === "ar") return ar_next_season_period(inputs)
	if (locale === "de") return de_next_season_period(inputs)
	if (locale === "es") return es_next_season_period(inputs)
	if (locale === "fr") return fr_next_season_period(inputs)
	if (locale === "it") return it_next_season_period(inputs)
	if (locale === "ja") return ja_next_season_period(inputs)
	if (locale === "ko") return ko_next_season_period(inputs)
	if (locale === "pt_br") return pt_br_next_season_period(inputs)
	if (locale === "ru") return ru_next_season_period(inputs)
	if (locale === "th") return th_next_season_period(inputs)
	if (locale === "tr") return tr_next_season_period(inputs)
	if (locale === "zh_cn") return zh_cn_next_season_period(inputs)
	return zh_tw_next_season_period(inputs)
});